module.exports = __webpack_public_path__ + "static/media/matrix-circle-1920.6b5b1958.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/matrix-circle-1920.jpg
// module id = 1363
// module chunks = 0